import { ReactNode } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Box, useTheme } from "@mui/material";

interface TagProps {
  children: ReactNode;
  variant: "success" | "error" | "info";
}

export const Tag = ({ children, variant }: TagProps) => {
  const theme = useTheme();
  const Colors: Record<
    TagProps["variant"],
    { color: string; backgroundColor: string }
  > = {
    success: {
      color: theme.palette.text.tonal.success, // TODO - CP
      backgroundColor: theme.igBackgroundColors.tonal.success,
    },
    error: {
      color: theme.palette.text.tonal.error,
      backgroundColor: theme.igBackgroundColors.tonal.error,
    },
    info: {
      color: theme.palette.text.tonal.info,
      backgroundColor: theme.igBackgroundColors.tonal.info,
    },
  };

  return (
    <Box
      sx={{
        padding: "5px",
        borderRadius: "5px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "18px",
        ...Colors[variant],
      }}
    >
      <IgTypography variant={"body2"} color={Colors[variant]}>
        {children}
      </IgTypography>
    </Box>
  );
};
